import { Link } from "react-router-dom";
import style from "./Breadcrumb.module.css";
import Icon from "../../a-atoms/icons/Icon";
import { useEffect, useRef, useState } from "react";
import useOutsideClick from "../../../hooks/useOutsideClick";
import { useSelector } from "react-redux";
import { db } from "../../../configs/Firebase";
import { set, ref, push, update } from "firebase/database";
import Button from "../buttons/Button";
import Dialog from "../../c-organism/dialogs/Dialog";
import Input from "../formElements/input/Input";
import { canManageAccess } from "../../../utils/permissions";

const Breadcrumb = (props) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const brandsRef = useRef();
  const outsideClick = useOutsideClick(brandsRef);
  const userStatus = useSelector((state) => state.userStatus.value);
  const [user, setUser] = useState(false);
  const orgsStatus = useSelector((state) => state.orgsStatus.value);
  const [orgs, setOrgsState] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (userStatus) {
      setUser(JSON.parse(userStatus.payload));
    }
  }, [userStatus]);

  useEffect(() => {
    if (selectedOrg && user) {
      // Owner is not technically admin but has full access - admin check is for organization workspaces only
      if (user.uid === selectedOrg.id) {
        setIsAdmin(false); // Owner is not admin (admin is for workspace management)
      } else {
        setIsAdmin(canManageAccess(user, selectedOrg.id));
      }
    }
  }, [user, selectedOrg]);

  useEffect(() => {
    if (orgsStatus) {
      let tempArr = [];
      for (let i in orgsStatus.payload) {
        tempArr.push({ id: i, ...orgsStatus.payload[i] });
        if (orgsStatus.payload[i].selected) {
          setSelectedOrg(orgsStatus.payload[i]);
        }
      }
      setOrgsState(tempArr);
    }
  }, [orgsStatus]);

  function showHandler() {
    setShowDropdown(!showDropdown);
  }

  useEffect(() => {
    setShowDropdown(false);
  }, [outsideClick]);

  function setOrgHandler(e, org) {
    for (let i in orgs) {
      if (orgs[i].id !== user.uid) {
        if (orgs[i].id === org.id) {
          set(
            ref(db, "userData/" + user.uid + "/linked/" + org.id + "/selected"),
            true
          );
        } else {
          set(
            ref(
              db,
              "userData/" + user.uid + "/linked/" + orgs[i].id + "/selected"
            ),
            false
          );
        }
      }
    }
  }

  const [showNewOrgDialog, setShowNewOrgDialog] = useState(false);
  const [newOrgName, setNewOrgName] = useState("");
  const [newOrgNameError, setNewOrgNameError] = useState("");
  function showNewOrgDialogHandler() {
    setShowNewOrgDialog(true);
  }
  function closeDialog() {
    setShowNewOrgDialog(false);
  }

  function orgNameChangeHandler(e) {
    setNewOrgName(e.target.value);
  }
  function saveNewOrg() {
    if (newOrgName.length > 2) {
      setNewOrgNameError("");
      push(ref(db, "userData/"), { profile: { name: newOrgName } }).then(
        (snap) => {
          update(ref(db, "userData/" + user.uid + "/linked/" + snap.key), {
            key: snap.key,
            selected: true,
          });
          setNewOrgName("");
          setShowNewOrgDialog(false);
        }
      );
    } else {
      setNewOrgNameError("Name must be at least 3 characters long");
    }
  }

  return (
    <>
      <ul className={`${style.ul} ${props.darkMode ? style.darkMode : ''}`}>
        <li className={style.li}>
          <div className={style.dropdown} onClick={showHandler}>
            <span className={style.icon}></span> {selectedOrg.name}{" "}
            <Icon>expand_more</Icon>
            <div
              ref={brandsRef}
              className={`${style.brands} ${showDropdown && style.show} ${props.darkMode ? style.darkMode : ''}`}
            >
              <ul>
                {orgs.map((org, index) => (
                  <li key={index} onClick={(e) => setOrgHandler(e, org)}>
                    {org.selected ? <Icon>check</Icon> : <Icon>&nbsp;</Icon>}
                    {org.name}
                  </li>
                ))}
              </ul>
              {isAdmin ? (
                <div className={style.upgrade}>
                  {/* <Button onClick={showNewOrgDialogHandler}>
                    Upgrade to Org
                  </Button> */}
                </div>
              ) : null}
            </div>
          </div>
        </li>
        {props.items && props.items.map((item, index) => (
          <li key={index} className={style.li}>
            <Link to={item.url}>{item.name}</Link>
          </li>
        ))}
      </ul>
      {isAdmin ? (
        <Dialog
          show={showNewOrgDialog}
          title="Create Org Workspace"
          onClose={closeDialog}
        >
          <div className={style.newDialog}>
            <Input
              onChange={orgNameChangeHandler}
              type="text"
              placeholder="e.g. Company Name"
              label="Workspace Name"
              value={newOrgName}
              error={newOrgNameError}
            />

            <Button onClick={saveNewOrg}>Create</Button>
          </div>
        </Dialog>
      ) : null}
    </>
  );
};

export default Breadcrumb;
